<template>
  <div class="dialog-wrap">
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-drawer
      title="批量修改"
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="520"
      destroy-on-close
      append-to-body
    >
      <div class="content-wrap">
        <div class="dialog-title">
          <p class="title">修改上课教室</p>
          <p class="total">已选择{{ originArray.length }}课时</p>
        </div>
        <el-form
          class="main-form"
          size="mini"
          :model="listingForm"
          ref="mainForm"
          label-width="110px"
        >
          <el-row>
            <el-col :span="20">
              <el-form-item label="上课教室:" prop="classroom_id">
                <el-select
                  v-model="listingForm.classroom_id"
                  filterable
                  clearable
                  placeholder="请选择"
                  :filter-method="handleSearchClassRoom"
                  @change="changeClassRoom"
                >
                  <el-option
                    v-for="item in searchClassRoomList"
                    :key="item.classroom_id"
                    :label="item.name"
                    :value="item.classroom_id"
                  >
                  </el-option>
                </el-select>
                <div class="max-people" v-if="classRoomPeople !== 0">
                  最多可容纳 {{ classRoomPeople }}人
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <div class="mwow-green add-class-room" @click="showAddClassRoom">
                新增
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div class="footer">
          <div class="btns">
            <div class="mwow-button-filled mini" @click="closeDialog">取消</div>
            <div class="mwow-button-filled mini success" @click="handleSubmit">
              保存
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 冲突弹窗 -->
    <el-dialog
      title="提示"
      destroy-on-close
      :visible.sync="conflictDialogVisible"
      append-to-body
    >
      <conflict-dialog
        :conflictData="conflictDialogData"
        :visible.sync="conflictDialogVisible"
        @submit="conflictConfirm"
      ></conflict-dialog>
    </el-dialog>
    <!-- 添加教室抽屉 -->
    <el-drawer
      title="添加教室"
      :visible.sync="addClassRoomDrawerVisible"
      direction="rtl"
      :size="416"
      destroy-on-close
      append-to-body
    >
      <add-dialog
        :visible.sync="addClassRoomDrawerVisible"
        :edit-info="''"
        @addClassRoomId="classRoomAddId"
      ></add-dialog>
    </el-drawer>
  </div>
</template>
<script>
import eventBus from "@/utils/bus";
import conflictDialog from "../log/conflictDialog.vue";
import { lessonClassroomConflictCheckApi } from "@/api/classSchedule";
import { classroomSelectListApi } from "@/api/classRoom";
import { mutiEditClassRoom } from "@/api/lesson";
import addDialog from "@/components/addClassRoomDialog.vue";

export default {
  components: {
    addDialog,
    conflictDialog,
  },
  // @Prop() ori!: any[];
  // @Prop() cid!: number;
  props: ["ori", "cid"],
  data() {
    return {
      originArray: [],
      listingForm: {
        classroom_id: 0,
        class_id: "",
      },
      searchClassRoomList: [],
      classRoomPeople: 0, // 可容纳人数
      addClassRoomDrawerVisible: false,
      dialogVisible: false,
      conflictDialogVisible: false,
      conflictDialogData: {},
    };
  },
  methods: {
    openDialog() {
      this.listingForm = {
        class_id: this.cid,
      };
      this.dialogVisible = true;
      this.originArray = [...this.ori];
      this.handleSearchClassRoom("");
      eventBus.$on("initClassRoomManagement", () => {
        this.handleSearchClassRoom("");
      });
    },
    classRoomAddId(id) {
      this.listingForm.classroom_id = id;
    },
    beforeDestroy() {
      eventBus.$off("initClassRoomManagement");
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleSearchClassRoom(v) {
      classroomSelectListApi({
        page: 1,
        page_size: 1000,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.searchClassRoomList = res.data.list;
          this.changeClassRoom(this.listingForm.classroom_id);
        }
      });
    },
    changeClassRoom(i) {
      if (!this.listingForm.classroom_id) {
        this.classRoomPeople = 0;
      }
      this.searchClassRoomList.map((item) => {
        if (item.classroom_id === i) {
          this.classRoomPeople = item.people;
        }
      });
    },
    showAddClassRoom() {
      this.addClassRoomDrawerVisible = true;
    },
    handleSubmit() {
      this.handleConflictCheck();
    },
    handleConflictCheck() {
      lessonClassroomConflictCheckApi({
        class_id: Number(this.cid),
        lesson_ids: [...this.originArray],
        classroom_id: this.listingForm.classroom_id,
      }).then((res) => {
        if (res.error_code === 0) {
          if (res.data.conflict) {
            this.conflictDialogVisible = true;
            this.conflictDialogData = res.data;
          } else {
            this.conflictConfirm();
          }
        }
      });
    },
    conflictConfirm() {
      const params = {
        lesson_ids: this.originArray,
        class_id: this.cid,
        classroom_id: this.listingForm.classroom_id,
      };
      mutiEditClassRoom(params).then(() => {
        this.$message({
          type: "success",
          message: "编辑成功",
        });
        this.closeDialog();
        this.$emit("change");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-wrap {
  display: inline-block;
}
.content-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .dialog-title {
    padding: 20px 0;
    margin: 0 47px;
    border-bottom: 1px dashed #e7e8ea;
    .title {
      font-size: 14px;
      line-height: 18px;
      color: #5c5d5e;
      margin-bottom: 17px;
      font-weight: bold;
    }
    .total {
      font-size: 12px;
      line-height: 16px;
      color: #ffb940;
    }
  }
  .main-form {
    flex: 1;
    padding: 16px 47px 16px 0;
  }
  .footer {
    padding: 20px;
    .btns {
      text-align: right;
      .mwow-button-filled {
        margin-left: 10px;
      }
    }
  }
}
/deep/ .el-select {
  width: 100%;
}
</style>
